export default "__VITE_ASSET__BZ212KcU__"